// import React from "react";
import { callGET,callPUT } from '../Utils/ApiUtil';
import {currencyListUtil,isSet,userUtilList} from './CommonFunctions';
import moment from 'moment';
import 'moment-timezone';
// import {authUserAuthorities} from '../store/actions/auth';
// return the user data from the session storage
export const getUserAuthorities = () => {
  const userStr = localStorage.getItem('user'); 
  if (userStr) return JSON.parse(userStr);
  else return null;
}
 
// return the token from the session storage
export const getToken = () => {
  return localStorage.getItem('access_token') || null;
}
 
// remove the token and user from the session storage
export const removeUserSession = () => {
  // console.log("removeUserSession");
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  localStorage.removeItem('moduleId');
  localStorage.removeItem('profileId');
  localStorage.removeItem('profile');
  localStorage.removeItem('importStatus');
  localStorage.removeItem('user_info');
  //for WindowIcons updation
  localStorage.removeItem('CustomWindowIcons')
  //For Menus updation
  localStorage.removeItem('ACTIVITY_REMINDER');
  localStorage.removeItem('windowsMenus');
  localStorage.removeItem('currencyList');
  localStorage.removeItem('userUtilList');
  localStorage.removeItem('windowsList');
  localStorage.removeItem('importStatus');
  localStorage.removeItem('defaultEmailConfig');
  //active email selection
  localStorage.removeItem("activeEmail");
}
 //get window Icons 
export const getWindowIcons =()=>{
  let CustomWindowIcons =localStorage.getItem('CustomWindowIcons');
  if(CustomWindowIcons) return JSON.parse(CustomWindowIcons);
  else return null;
 }
// set the token and user from the session storage
export const setUserAuthoritiesSession = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
  // localStorage.setItem('moduleId', user.data[0].module_id);
  localStorage.setItem('profileId', user.data[0].profile_id);
  localStorage.setItem('CustomWindowIcons',JSON.stringify(user.data[0].window_icons));
  // windowsMenusList();
  // localStorage.setItem('user', JSON.stringify(user));
}


//Get current user email selection 
export const getActiveEmail = () =>{
  // console.log("getActiveEmail",localStorage.getItem("activeEmail"));
  let activeEmail = localStorage.getItem("activeEmail");
  if(activeEmail!=null){
    return JSON.parse(activeEmail);
  }else {
    return null;
  }
}
// Set current user email selection for email container
export const setActiveEmail = (email) =>{
  // console.log("setActiveEmail",email)
  localStorage.setItem("activeEmail",JSON.stringify(email))
}

// set the token and user from the session storage
export const setCurrentModuleId = (moduleId) => {
  localStorage.setItem('moduleId', moduleId);
}

// set the token and user from the session storage
export const setUserSession = (userAccessData) => {
  localStorage.setItem('access_token', userAccessData.access_token);
  localStorage.setItem('refresh_token', userAccessData.refresh_token);
  // console.log('CALL ACTIVITY....');
  getActivityReminderDetails();
  currencyListUtil();
  userUtilList();
}

export const getCurrentModuleId = () => {
  return localStorage.getItem('moduleId');
}


// get current logged in Profile ID
export const getCurrentProfileId = () => {
  return localStorage.getItem('profileId');
}

// set the token and profile from the session storage
export const setProfileAuthoritiesSession = (profile) => {
  //console.log(JSON.stringify(profile) + 'profilesssss')
  localStorage.setItem('profile', JSON.stringify(profile));  
}

// set the token and profile from the session storage
export const setProfileAuthoritiesSessionEmpty = () => {
  //console.log(JSON.stringify(profile) + 'profilesssss')
  localStorage.setItem('profile', '');  
}

// set the token and profile from the session storage
export const setImportStatus = (data) => {
  //console.log(JSON.stringify(profile) + 'profilesssss')
  localStorage.setItem('importStatus', data);  
}

export const getImportStatus = (data) => {
  //console.log(JSON.stringify(profile) + 'profilesssss')
  return localStorage.getItem('importStatus');  
}

export const setDefaultEmailConfig = (data) => {
  // console.log(JSON.stringify(data),data);
  localStorage.setItem('defaultEmailConfig', JSON.stringify(data)); 
}

export const getDefaultEmailConfig = () => {
  const defaultEmailConfig =  localStorage.getItem('defaultEmailConfig');
  return JSON.parse(defaultEmailConfig);
}
// return the user data from the session storage
export const getProfileAuthorities = () => {
  const profileStr = localStorage.getItem('profile'); 
  // if(profileStr){
  //   console.log('yesss')
  // }else{
  //   console.log('noooo')
  // }
  if (profileStr) return JSON.parse(profileStr);
  else return null;
  //return JSON.parse(profileStr)
}

/*export const getDefaultModule = () => {
  return localStorage.getItem('defaultModule');  
}

export const setDefaultModule = (data) => {
  localStorage.setItem('defaultModule', data);  
}*/

// return the user data from the session storage
export const getUserAuthoritiesWindow = (moduleId) => {
  localStorage.removeItem('moduleId');
  localStorage.setItem('moduleId', moduleId);

  const userAuthorities = getUserAuthorities();
  const userModuleWindow = [];
  if(userAuthorities?.data!==undefined){
    try{
      isSet(isSet(userAuthorities,{data:[]}).data,[]).forEach((arr,i) => {
        if(arr.id === moduleId) {
           userModuleWindow.push(arr.windows);
        }
      });
    }catch(e){

    }
    
  }
  
  // console.log("UserAuthoritiesWindow----------->",userModuleWindow);
  return (userModuleWindow.length>0)?userModuleWindow[0]:userModuleWindow;
}

export const getCurrentUserAuthoritiesWindow = () => {
  const moduleId = localStorage.getItem('moduleId');
  const userAuthorities = getUserAuthorities();
  const userModuleWindow = [];
  try{
    if(userAuthorities.data!==undefined){
      userAuthorities.data.forEach((arr,i) => {
        if(arr.id === moduleId) {
          userModuleWindow.push(arr.windows);
        }
      });
    }
  }catch(e){

  }
  
  return (userModuleWindow.length>0)?userModuleWindow[0]:userModuleWindow;
}

export const getUserWindows = () => {
  // const moduleId = localStorage.getItem('moduleId');
  const userAuthorities = getUserAuthorities();
  const userModuleWindow = [];
  if(userAuthorities.data!==undefined){
    userAuthorities.data.forEach((arr,i) => {
      // if(arr.module_id === moduleId) {
        userModuleWindow.push(...arr.windows);
        // userModuleWindow.push.apply(userModuleWindow,arr.windows);
      // }
    });
  }
  return userModuleWindow;
}


// set user info details
export const setUserInfoSession = (userDetailsData) => {
  localStorage.setItem('user_info', JSON.stringify(userDetailsData));  
}

// to get user info details
export const getUserInfo = () => {  
  const userInfo = localStorage.getItem('user_info'); 
  if (userInfo) return JSON.parse(userInfo);
  else return null;  
}

// to get user info details
export const getLoggedInUserId = () => {  
  const userInfo = getUserInfo();
  const id = userInfo && userInfo.data ? userInfo.data.id : '';
  return id;  
}

// GET LOGGED IN USER TIMEZONE
export const getUserTimeZone = ()=>{
  let userInfo = localStorage.getItem('user_info'); 
  try{
    userInfo = JSON.parse(userInfo);
    if(userInfo.data!==undefined && userInfo.data!==null){
        return isSet(userInfo.data.timezone_id,'Canada/Mountain');
    }
    return 'Canada/Mountain';
  }catch(e){
    return 'Canada/Mountain';
  }
}

/** Current date/time in the logged-in user's timezone (matches Header clock when moment has no zone data). */
// Returns current date/time as a moment in the logged-in user's timezone (see getUserTimeZone).
// Fallback matches Header clock when moment has no data for that zone id.
export const getUserMoment = () => {
  const tz = getUserTimeZone();
  try {
    if (moment.tz && moment.tz.zone && moment.tz.zone(tz)) {
      return moment().tz(tz);
    }
    const convertUserTime = new Date().toLocaleString('en-US', { timeZone: tz });
    return moment(new Date(convertUserTime));
  } catch (e) {
    return moment();
  }
};

// GET LOGGED IN USER ORG TIMEZONE
export const getOrgTimeZone = ()=>{
  let userInfo = localStorage.getItem('user_info'); 
  try{
    userInfo = JSON.parse(userInfo);
    if(userInfo.data && userInfo.data.org_info && userInfo.data.org_info.time_zone_id){
        return userInfo.data.org_info.time_zone_id;
    }
    return 'Canada/Mountain';
  }catch(e){
    return 'Canada/Mountain';
  }
}

// get date format
//isDateTime : For Date + Time should pass 'DateTime'
export const getDateFormat = (isDateTime='Date') => {
  const userInfo = getUserInfo();
  const date_pattern_value = userInfo.data.date_pattern_value;
  if(isDateTime==='DateTime' || isDateTime==='Reminder'){
    return date_pattern_value+" HH:mm:ss";
  }else{
    // return "YYYY/MM/DD";
    return date_pattern_value;
  }
  
}

export const getDateFormatPicker = (isDateTime='Date') => {
  const userInfo = getUserInfo();
  const date_pattern_value = userInfo && userInfo.data ? userInfo.data.date_pattern_value : '';
  if(isDateTime==='DateTime'){
    return date_pattern_value+" HH:mm:ss";
  }else{
    // return "YYYY/MM/DD";
    return date_pattern_value;
  }
  
}

// Check login user is system user
export const checkIsSystemUser = () => {
    const userInfo = getUserInfo();
    const isSystemUser = userInfo && userInfo.data ? userInfo.data.is_system_user : false;
    if(isSystemUser) {
      return isSystemUser;
    }else {
      return false;
    }
}
  
// check login user is organization admin
export const checkIsOrganizationAdmin = () => {
    const userInfo = getUserInfo();
    const isOrgAdmin = userInfo && userInfo.data ? userInfo.data.is_organization_admin : false;
    if(isOrgAdmin) {
      return isOrgAdmin;
    }else {
      return false;
    }
}

export const windowsMenusList = ()=> {
  // alert('ss');
  const windowsMenus = localStorage.getItem('windowsMenus');
  // let data = [];		
  if(windowsMenus===null || windowsMenus===undefined || windowsMenus===''){ 
		/*const url = 'users/userAuthorities';
    callGETASYNC(url)
	    .then(response => {
			console.log(response);
        setUserAuthoritiesSession(response.code === 200 ? response : data);
        
			})
	    .catch(err => {
	    	if(err.response){
	    		console.log("errror============",err.response); 
	   	 	}
      })*/
  }else{
    return localStorage.getItem('windowsMenus');
  }
  return getUserAuthorities();
}


export const windowsMenusListData = ()=> {
  // alert('ss');
  // const windowsMenus = null;
  // let data = [];		
  // if(windowsMenus===null || windowsMenus===undefined || windowsMenus===''){ 
	// 	const url = 'users/userAuthorities';
  //   callGETASYNC(url)
	//     .then(response => {
	// 		console.log(response);
  //       setUserAuthoritiesSession(response.code === 200 ? response : data);
        
	// 		})
	//     .catch(err => {
	//     	if(err.response){
	//     		console.log("errror============",err.response); 
	//    	 	}
  //     })
  // }else{
  //   return localStorage.getItem('windowsMenus');
  // }
  // return getUserAuthorities();

  
}

export const getActivityReminderDetails = (callback=()=>{})=>{
  // console.log(moment().format());
  const Date = moment().tz(getUserTimeZone()).format('YYYY-MM-DD');
  const Time = moment().tz(getUserTimeZone()).format('HH:MM');
  const API_Url = 'reminders/list?aftrDt='+Date+'&aftrTm='+Time;

  callGET(API_Url)
    .then(res => {
      if(res.status===200){ 
        const response = res.data;
        // console.log(response);
        if(response.code===200){
            const responseData = response.data;
            localStorage.setItem('ACTIVITY_REMINDER',JSON.stringify(responseData));
            callback();
            // reminderSetTimeInterval(responseData);
            // console.log();
            // responseData.ma
          }
        }
    })
    .catch(err => {
      if(err.response){
        // ACTIVITY_REMINDER
        localStorage.removeItem('ACTIVITY_REMINDER');
        console.log("errror============",err.response); 
        }
    })
  return true;
}

export const dismissActivityReminderDetails = (reminderId,callback=()=>{})=>{
  // console.log(moment().format());
  const API_Url = 'reminders/'+reminderId+'/dismiss';
  callPUT(API_Url)
    .then(res => {
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
            // const responseData = response.data;
            getActivityReminderDetails(callback);
            // localStorage.setItem('ACTIVITY_REMINDER',JSON.stringify(responseData));
            // reminderSetTimeInterval(responseData);
            // console.log();
            // responseData.ma
          }
        }
    })
    .catch(err => {
      if(err.response){
        // ACTIVITY_REMINDER
        localStorage.removeItem('ACTIVITY_REMINDER');
        // console.log("errror============",err.response); 
        }
    })
  return true;
}

export const getWindowObjectUsingWindowName = (windowName) => {
  // const windowList = getCurrentUserAuthoritiesWindow();
  let obj = null;
  /*if(windowList) {
    windowList.forEach((windArr,windInd) => {
      if(windArr.window_name === windowName) {
        obj = windArr;
      }
    })
  }*/
  const userAuthorities = getUserAuthorities();
  if(userAuthorities.data) {
    userAuthorities.data.forEach((item,ind) => {
      if(item.windows) {
        item.windows.forEach((winItem,windInd)=> {
          if(windowName === winItem.window_name) {
            obj=winItem;
          }
        })
      }
    })
  }
  return obj;
}

export const getWindowObjectUsingWindowId = (windowId) => {
  let returnData='';
  const userAuthorities = getUserAuthorities();
  if(userAuthorities.data) {
    userAuthorities.data.forEach((item,ind) => {
      if(item.windows) {
        item.windows.forEach((winItem,windInd)=> {
          if(windowId === winItem.window_id) {
            returnData=winItem;
          }
        })
      }
    })
  }
  return returnData;
}

export const getOrgId = () => {
  const userInfo = getUserInfo();
  const org_id = userInfo.data.org_id;
  return org_id;
}

export const getDefaultModule = () => {
  const userInfo = getUserInfo();
  if(userInfo && userInfo.data && userInfo.data.user_preference && userInfo.data.user_preference.default_module) {
    return userInfo.data.user_preference.default_module;
  }else {
    return null;
  }
  
}

export const getWindowNameUsingDefinedName = (name) => {
  let returnData='';
  const userAuthorities = getUserAuthorities();
  if(userAuthorities.data) {
    userAuthorities.data.forEach((item,ind) => {
      if(item.windows) {
        item.windows.forEach((winItem,windInd)=> {
          if(name === winItem.system_defined_name) {
            returnData=winItem.window_name;
          }
        })
      }
    })
  }
  return returnData;
}

export const getWindowUsingWindowName = (name) => {
  let returnData='';
  const userAuthorities = getUserAuthorities();
  // console.log(userAuthorities);
  if(userAuthorities.data) {
    userAuthorities.data.forEach((item,ind) => {
      if(item.windows) {
        item.windows.forEach((winItem,windInd)=> {
          if(name === winItem.window_name) {
            returnData=winItem;
          }
        })
      }
    })
  }
  return returnData;
}

export const getWindowNameUsingDefinedNameWithList = (name,windowsList) => {
  let returnData='';
  if(windowsList) {
    windowsList.forEach((item,ind) => {
      if(name === item.window_name) {
        returnData=item.display_name;
      }
    })
  }
  return returnData;
}

export const setGoBackURL = (url) => {
  let urls = getGoBackURL();
  if(urls) {
    if(Array.isArray(urls) && urls[urls.length - 1] !== url)
    urls.push(url);
  }else {
    urls = [url];
  }
  // console.log(urls);
  localStorage.setItem('goBackURL', JSON.stringify(urls));  
}

export const getGoBackURL = () => {
  let returnVal = [];
  let returndata = localStorage.getItem('goBackURL');;
  try{
    returnVal = JSON.parse(returndata);
  } catch (error) {
    returnVal = [];
  }
  return returnVal;
}

export const reduceGoBackURL = () => {
  let urls = getGoBackURL();
  urls.pop();
  localStorage.setItem('goBackURL', JSON.stringify(urls));
}

export const clearGoBackURL = () => {
  localStorage.removeItem('goBackURL');
}

export const defaultPerpageUsingWindowId = (windInd) => {
  let returnVal = null;
  const userInfo = getUserInfo();
  try{
    if(userInfo.data && 
        userInfo.data.user_preference && 
        userInfo.data.user_preference.pagination_preferences && 
        userInfo.data.user_preference.pagination_preferences.length > 0) {
          userInfo.data.user_preference.pagination_preferences.forEach(item => {
            const windId = Object.keys(item)[0];
            if(windId === windInd) {
              returnVal = item[windId];
            }
          })
    }
  } catch (error) {
    returnVal = null;
  }
  return returnVal;
}

export const setNavigationHistory = (url) => {
  let urls = getGoBackURL();
  if(urls) {
    if(Array.isArray(urls) && urls[urls.length - 1] !== url)
    urls.push(url);
  }else {
    urls = [url];
  }
  // console.log(urls);
  localStorage.setItem('navigationHistory', JSON.stringify(urls));  
}

export const getNavigationHistory = () => {
  let returnVal = [];
  let returndata = localStorage.getItem('navigationHistory');;
  try{
    returnVal = JSON.parse(returndata);
  } catch (error) {
    returnVal = [];
  }
  return returnVal;
}

export const getWindowAutoritiesUsingWindowId = (windowId) => {
  let returnVal = null;
  const profileAutorities = getProfileAuthorities();
  if(profileAutorities && profileAutorities.data.windows) {
    profileAutorities.data.windows.forEach(item => {
      if(item.window_id === windowId) {
        returnVal = item.window_authorities;
      }
    })
  }
  return returnVal;
}

export const checkIsModuleAvaibale = (moduleName) => {
  let returnVal = true;
  if(getProfileAuthorities()!==null && getProfileAuthorities().code===200/* && getProfileAuthorities().data.length>0*/){
    getProfileAuthorities().data.user_settings.forEach((action, index) => {
        if(action.title===moduleName){                  
            returnVal = action.is_manage;
        }
    })
  }
  return returnVal;
}

export const preventNonNumericalInput = (e) => {  
  //if(this.props.isAllowNegative===false){
    e = e || window.event;
    let charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
    let charStr = String.fromCharCode(charCode);
    
    if (!charStr.match(/^[0-9]+$/))
      e.preventDefault();
  //}
}

export const getWindowNameUsingWindowId = (windowId) => {
  let returnVal = null;
  const profileAutorities = getProfileAuthorities();
  if(profileAutorities && profileAutorities.data.windows) {
    profileAutorities.data.windows.forEach(item => {
      if(item.window_id === windowId) {
        returnVal = item;
      }
    })
  }
  return returnVal;
}

export const isValidEmail = (email) => {
  return /^[a-zA-Z0-9.]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email);
}

export const getUnique = (arr, index) => {

  const unique = arr
       .map(e => e[index])

       // store the keys of the unique objects
       .map((e, i, final) => final.indexOf(e) === i && i)
  
       // eliminate the dead keys & store unique objects
      .filter(e => arr[e]).map(e => arr[e]);      

   return unique;
}

export const getModuleList = () => {
  let returnData=[];
  const userAuthorities = getUserAuthorities();
  if(userAuthorities.data) {
    userAuthorities.data.forEach((item,ind) => {
      returnData.push({
        name:item.module_name,
        value:item.id,
        system_generated:item.system_generated
      });
    });
  }
  return returnData;
}

export const getCustomCreatedModuleList = () => {
  let returnData=[];
  const userAuthorities = getUserAuthorities();
  if(userAuthorities.data) {
    userAuthorities.data.forEach((item,ind) => {
      // if(item.system_generated === false) {
        returnData.push({
          name:item.module_name,
          value:item.id,
          system_generated:item.system_generated
        });
      // }
    });
  }
  return returnData;
}

export const checkIsCustomCreatedModule = (id) => {
  let returnData=false;
  const userAuthorities = getUserAuthorities();
  if(userAuthorities.data) {
    userAuthorities.data.forEach((item,ind) => {
      if(item.id === id) {
        returnData = item.system_generated;
      }
    });
  }
  return returnData;
}

export const getCustomCreatedUserWindows = () => {
  // const moduleId = localStorage.getItem('moduleId');
  const userAuthorities = getUserAuthorities();
  const userModuleWindow = [];
  if(userAuthorities.data!==undefined){
    userAuthorities.data.forEach((arr,i) => {
      arr.windows.forEach((wind,ind) => {
        if(wind.system_created_window === false) {
          wind.moduleId = arr.id;
          wind.moduleName = arr.module_name;
          userModuleWindow.push(wind);
        }
      });
    });
  }
  return userModuleWindow;
}

export const getModuleById = (id) => {
  let returnData=null;
  const userAuthorities = getUserAuthorities();
  if(userAuthorities.data) {
    userAuthorities.data.forEach((item,ind) => {
      if(item.id === id) {
        returnData = item;
      }
    });
  }
  return returnData;
}

export const checkIsCustomCreatedWindow = (id) => {
  let returnVal = null;
  const profileAutorities = getProfileAuthorities();
  if(profileAutorities && profileAutorities.data.windows) {
    profileAutorities.data.windows.forEach(item => {
      if(item.window_id === id) {
        returnVal = item.system_created_window;
      }
    })
  }
  return returnVal;
}